module.exports = __webpack_public_path__ + "media/reskin-images/icon--phone-7db06557.svg";